'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var cast_1 = require("./cast");
var check_1 = require("./check");
var json_1 = require("./json");
var numberFormatFunction;
var intl;
try {
    intl = eval('Intl');
}
catch (_a) {
}
if (intl) {
    numberFormatFunction = function (numberToFormat, currencyStr, locales) {
        return new Intl
            .NumberFormat(locales, {
            currency: currencyStr,
            localeMatcher: 'best fit',
            maximumFractionDigits: 2,
            minimumFractionDigits: 0,
            style: 'currency'
        })
            .format(numberToFormat);
    };
}
else {
    numberFormatFunction = function (numberToFormat, currency, locales) {
        return numberToFormat + " " + currency;
    };
}
var Str;
(function (Str) {
    function trim(value, skipNotString) {
        if (skipNotString === void 0) { skipNotString = true; }
        if (!check_1.Check.isString(value)) {
            if (!skipNotString) {
                var error = "Str.trim(" + json_1.Json.encode(value) + ") - Value is not a string.";
                console.error(error);
                console.trace(error);
            }
            value = cast_1.Cast.toString(value);
        }
        return value.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
    Str.trim = trim;
    function currency(numberToFormat, currency, locales) {
        return numberFormatFunction(numberToFormat, currency, locales);
    }
    Str.currency = currency;
    function multiReplace(subject, search, replace) {
        if (replace === void 0) { replace = null; }
        if (check_1.Check.isString(search)) {
            if (check_1.Check.isString(replace)) {
                return subject.split(search).join(replace);
            }
            replace = check_1.Check.isNil(replace) ? '' : cast_1.Cast.toSingle(replace);
            return multiReplace(subject, search, replace);
        }
        if (check_1.Check.isArray(search)) {
            if (check_1.Check.isArray(replace)) {
                return search
                    .reduce(function (rSubject, rSearch, rIndex) {
                    return multiReplace(rSubject, rSearch, replace[rIndex]);
                }, subject);
            }
            replace = check_1.Check.isNil(replace) ? '' : replace;
            return search
                .reduce(function (rSubject, rSearch) {
                return multiReplace(rSubject, rSearch, replace);
            }, subject);
        }
        if (check_1.Check.isPlainObject(search)) {
            var oSearch = Object.keys(search);
            var oReplace_1 = oSearch.map(function (key) { return search[key]; });
            return (oSearch)
                .reduce(function (rSubject, rSearch, rIndex) {
                return multiReplace(rSubject, rSearch, oReplace_1[rIndex]);
            }, subject);
        }
        return subject;
    }
    Str.multiReplace = multiReplace;
    function removeFormatting(text) {
        return multiReplace(text, [' ', '\t', '\n', '\r', '\0', '\x0B', '&nbsp;', '&#160;']);
    }
    Str.removeFormatting = removeFormatting;
    function hash(value, asString, seed) {
        if (asString === void 0) { asString = true; }
        if (seed === void 0) { seed = 0x811c9dc5; }
        var text = check_1.Check.isString(value) ? value : json_1.Json.encode(value);
        var length = text.length;
        var index = 0;
        var hashVal = seed;
        for (index; index < length; index += 1) {
            hashVal ^= text.charCodeAt(index);
            hashVal += (hashVal << 1) + (hashVal << 4) + (hashVal << 7) + (hashVal << 8) + (hashVal << 24);
        }
        if (asString) {
            return ('0000000' + (hashVal >>> 0).toString(16)).substr(-8);
        }
        return hashVal >>> 0;
    }
    Str.hash = hash;
    function replaceBetween(subject, start, end, stuffWith) {
        return subject.substring(0, start) + stuffWith + subject.substring(end);
    }
    Str.replaceBetween = replaceBetween;
    function replaceFromTo(subject, from, to, stuffWith, withTo) {
        if (stuffWith === void 0) { stuffWith = ''; }
        if (withTo === void 0) { withTo = false; }
        if (subject.length === 0) {
            return '';
        }
        var start = subject.indexOf(from);
        var stop = subject.indexOf(to, start);
        if (start === -1 || stop === -1) {
            return subject;
        }
        if (withTo) {
            stop += to.length;
        }
        return replaceBetween(subject, start, stop, stuffWith);
    }
    Str.replaceFromTo = replaceFromTo;
    function extractFromTo(subject, from, to) {
        if (subject.length === 0) {
            return '';
        }
        var start = subject.indexOf(from);
        var stop = subject.indexOf(to, start);
        if (start === -1 || stop === -1) {
            return subject;
        }
        return subject.substring(start + from.length, stop);
    }
    Str.extractFromTo = extractFromTo;
    function utf8decode(utftext) {
        var str = '';
        var index = 0;
        var c = 0;
        var c1 = 0;
        var c2 = 0;
        while (index < utftext.length) {
            c = utftext.charCodeAt(index);
            if (c < 128) {
                str += String.fromCharCode(c);
                index++;
            }
            else if ((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(index + 1);
                str += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                index += 2;
            }
            else {
                c2 = utftext.charCodeAt(index + 1);
                c1 = utftext.charCodeAt(index + 2);
                str += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c1 & 63));
                index += 3;
            }
        }
        return str;
    }
    Str.utf8decode = utf8decode;
    function utf8encode(str) {
        var utfText = '';
        str = str.replace(/\r\n/g, '\n');
        for (var n = 0; n < str.length; n++) {
            var c = str.charCodeAt(n);
            if (c < 128) {
                utfText += String.fromCharCode(c);
            }
            else if ((c > 127) && (c < 2048)) {
                utfText += String.fromCharCode((c >> 6) | 192);
                utfText += String.fromCharCode((c & 63) | 128);
            }
            else {
                utfText += String.fromCharCode((c >> 12) | 224);
                utfText += String.fromCharCode(((c >> 6) & 63) | 128);
                utfText += String.fromCharCode((c & 63) | 128);
            }
        }
        return utfText;
    }
    Str.utf8encode = utf8encode;
})(Str = exports.Str || (exports.Str = {}));



//////////////////
// WEBPACK FOOTER
// ./src/typescripts/shared/utils/str.ts
// module id = 29
// module chunks = 0 1